import React, {PureComponent} from 'react';
import {
  View,
  ViewProps,
  LayoutChangeEvent,
  StyleProp,
  ViewStyle,
} from 'react-native';

export interface LinearGradientProps extends ViewProps {
  colors: (string | number)[];
  start?: {x: number; y: number};
  end?: {x: number; y: number};
  locations?: number[];
  useAngle?: boolean;
  angleCenter?: {x: number; y: number};
  angle?: number;
}

interface LinearGradientState {
  width: number;
  height: number;
}

export default class LinearGradient extends PureComponent<
  LinearGradientProps,
  LinearGradientState
> {
  static defaultProps: Partial<LinearGradientProps> = {
    start: {x: 0.5, y: 0},
    end: {x: 0.5, y: 1},
    locations: [],
    colors: [],
    useAngle: false,
    angle: 0,
  };

  state: LinearGradientState = {
    width: 1,
    height: 1,
  };

  private measure = (event: LayoutChangeEvent) => {
    const {width, height} = event.nativeEvent.layout;
    this.setState({width, height});
    this.props.onLayout?.(event);
  };

  private getAngle = (): string => {
    const {useAngle, angle, start, end} = {
      ...LinearGradient.defaultProps,
      ...this.props,
    };
    if (useAngle) {
      return `${angle}deg`;
    }
    const {width, height} = this.state;
    const rad =
      Math.atan2(width * (end!.y - start!.y), height * (end!.x - start!.x)) +
      Math.PI / 2;
    return `${rad}rad`;
  };

  private getColors = (): string =>
    this.props.colors
      .map((color, i) => {
        const loc = this.props.locations?.[i];
        return `${color}${loc != null ? ` ${loc * 100}%` : ''}`;
      })
      .join(',');

  render() {
    const {style, children, ...other} = this.props;
    const gradientStyle: StyleProp<ViewStyle> = {
      //@ts-ignore
      backgroundImage: `linear-gradient(${this.getAngle()},${this.getColors()})`,
    };

    return (
      <View {...other} style={[style, gradientStyle]} onLayout={this.measure}>
        {children}
      </View>
    );
  }
}
export {LinearGradient};
